// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-input {
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 20px 205px 40px 40px;
}

.chat-input-rounded-rect {
  width: calc(100% - 120px);
  height: 80%;
  background-color: #fff; /* Background color for the rounded input */
  border-radius: 20px; /* Adjust the border-radius for different levels of rounding */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  padding: 10px;
  color: #fff; /* Text color inside the input */
}

.chat-input-rounded-rect.disabled {
  background-color: rgba(228, 228, 228, 50);
}

.vertical-layout {
  display: flex;
  flex-direction: column;
}

.circle-plus {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  color: #000000;
}

.comment {
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  z-index: 1;
  color: #000000;
}

.chat-input-button-send-group {
  padding-top: 10px;
  height: 30px;
  position: relative;
}

.chat-input-button-send {
  width: 54px;
  height: 54px;
  cursor: pointer;
  color: white;
  background-color: #2895eb;
  border-radius: 10px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.share-chat {
  width: 54px;
  height: 54px;
  cursor: pointer;
  color: white;
  background-color: #2895eb;
  border-radius: 10px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.share-chat:disabled {

  color: white;
  background-color: grey;

}
.chat-input-button-send svg {
  color: white;
  width: 40px;
  height: 40px;
}

.chat-input-button-send:hover {
  color: #2e2e2e;
}

.chat-input-button-send:active {
  color: #b1b1b1;
}

.chat-input-button-send:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  color: gray;
}

.chat-input-button-learn {
  position: absolute;
  width: 40px;
  height: 30px;
  right: 60px;
  border: none;
  cursor: pointer;
  background-color: #fff;
  color: black;
  transition: color 0.3s ease;
}

.chat-input-button-learn-inactive:hover {
  color: #2e2e2e;
}

.chat-input-button-learn-inactive:active {
  color: #b1b1b1;
}

.chat-input-button-learn-inactive {
  position: absolute;
  width: 40px;
  height: 30px;
  right: 60px;
  border: none;
  cursor: pointer;
  background-color: #fff;
  color: rgb(190, 190, 190);
}

.chat-input-box {
  border-radius: 10px;
  border: 1px solid #2895eb;
  padding: 15px 20px;
  box-sizing: border-box;
  flex: 1 1;
}

.chat-input-textarea-field {
  background: #fff;
  border: none;
  padding: unset;
  width: 100%;
  resize: none;
  outline: none;
  font-size: 16px;
  line-height: 18px;
  font-weight: 400;
  box-sizing: border-box;
}

.chat-input-textarea-field::-webkit-scrollbar {
  width: 6px;
}

.chat-input-textarea-field::-webkit-scrollbar-thumb {
  background-color: #a6a5a5;
  border-radius: 20px;
}

.chat-input-textarea-field::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.chat-input-textarea-field::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
}

.chat-input-button-container {
  position: relative;
  bottom: 10px;
  right: 10px;
  display: flex;
  float: right;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/chat/ChatInput.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB,EAAE,2CAA2C;EACnE,mBAAmB,EAAE,8DAA8D;EACnF,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW,EAAE,gCAAgC;AAC/C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,QAAQ;EACR,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,sBAAsB;;AAExB;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,YAAY;AACd","sourcesContent":[".chat-input {\n  position: relative;\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  padding: 20px 205px 40px 40px;\n}\n\n.chat-input-rounded-rect {\n  width: calc(100% - 120px);\n  height: 80%;\n  background-color: #fff; /* Background color for the rounded input */\n  border-radius: 20px; /* Adjust the border-radius for different levels of rounding */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  color: #fff; /* Text color inside the input */\n}\n\n.chat-input-rounded-rect.disabled {\n  background-color: rgba(228, 228, 228, 50);\n}\n\n.vertical-layout {\n  display: flex;\n  flex-direction: column;\n}\n\n.circle-plus {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n  color: #000000;\n}\n\n.comment {\n  position: absolute;\n  transform: translate(-50%, -50%);\n  top: 50%;\n  left: 50%;\n  z-index: 1;\n  color: #000000;\n}\n\n.chat-input-button-send-group {\n  padding-top: 10px;\n  height: 30px;\n  position: relative;\n}\n\n.chat-input-button-send {\n  width: 54px;\n  height: 54px;\n  cursor: pointer;\n  color: white;\n  background-color: #2895eb;\n  border-radius: 10px;\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.share-chat {\n  width: 54px;\n  height: 54px;\n  cursor: pointer;\n  color: white;\n  background-color: #2895eb;\n  border-radius: 10px;\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.share-chat:disabled {\n\n  color: white;\n  background-color: grey;\n\n}\n.chat-input-button-send svg {\n  color: white;\n  width: 40px;\n  height: 40px;\n}\n\n.chat-input-button-send:hover {\n  color: #2e2e2e;\n}\n\n.chat-input-button-send:active {\n  color: #b1b1b1;\n}\n\n.chat-input-button-send:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n  color: gray;\n}\n\n.chat-input-button-learn {\n  position: absolute;\n  width: 40px;\n  height: 30px;\n  right: 60px;\n  border: none;\n  cursor: pointer;\n  background-color: #fff;\n  color: black;\n  transition: color 0.3s ease;\n}\n\n.chat-input-button-learn-inactive:hover {\n  color: #2e2e2e;\n}\n\n.chat-input-button-learn-inactive:active {\n  color: #b1b1b1;\n}\n\n.chat-input-button-learn-inactive {\n  position: absolute;\n  width: 40px;\n  height: 30px;\n  right: 60px;\n  border: none;\n  cursor: pointer;\n  background-color: #fff;\n  color: rgb(190, 190, 190);\n}\n\n.chat-input-box {\n  border-radius: 10px;\n  border: 1px solid #2895eb;\n  padding: 15px 20px;\n  box-sizing: border-box;\n  flex: 1;\n}\n\n.chat-input-textarea-field {\n  background: #fff;\n  border: none;\n  padding: unset;\n  width: 100%;\n  resize: none;\n  outline: none;\n  font-size: 16px;\n  line-height: 18px;\n  font-weight: 400;\n  box-sizing: border-box;\n}\n\n.chat-input-textarea-field::-webkit-scrollbar {\n  width: 6px;\n}\n\n.chat-input-textarea-field::-webkit-scrollbar-thumb {\n  background-color: #a6a5a5;\n  border-radius: 20px;\n}\n\n.chat-input-textarea-field::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n}\n\n.chat-input-textarea-field::-webkit-scrollbar-corner {\n  background-color: #f1f1f1;\n}\n\n.chat-input-button-container {\n  position: relative;\n  bottom: 10px;\n  right: 10px;\n  display: flex;\n  float: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
